/**
 * Application entry point for the Musedrops admin interface.
 *
 * This file bootstraps the React application and mounts it to the DOM.
 * It includes React StrictMode for development warnings and better debugging.
 *
 * @fileoverview React application bootstrap and DOM mounting
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Swap favicon and update title based on environment
const env = import.meta.env.VITE_ENV;
if (env === 'local') {
  const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  if (link) {
    link.href = '/favicon-local.ico';
  }
  document.title = 'Admin-LOCAL - Musedrops';
} else if (env === 'development') {
  const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  if (link) {
    link.href = '/favicon-dev.ico';
  }
  document.title = 'Admin-DEV - Musedrops';
} else {
  document.title = 'Admin-PROD - Musedrops';
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
